/**
 * @description: 积分兑换
 * @author: hwx
 * @update: lyr
 */
<template>
	<div>
		<!-- 列表 -->
		<div class="point-list" v-show="!showDetail">
			<div class="row">
				<label class="ct-label">门店:</label>
				<div class="col-md-2 ct-col">
					<select class="form-control" ref="shop" data-placeholder="请选择门店"></select>
				</div>
				<label class="ct-label">兑换类型:</label>
				<div class="col-md-2 point-type">
					<select class="form-control select2" ref="search_type" data-placeholder="请选择类型"></select>
				</div>
				<label class="ct-label">类型名称:</label>
				<div class="col-md-2 point-type">
					<select class="form-control select2" ref="search_goods_type" data-placeholder="请选择"></select>
				</div>
				<label class="ct-label">名称:</label>
				<div class="col-lg-2 ct-col">
					<input type="text" class="form-control" placeholder="请输入套餐/商品别名" v-model="search_goods_name">
				</div>
				<div class="pull-right">
					<button type="button" class="btn btn-flat btn-small btn-orange" @click="clkQuery" style="margin-right:10px">查询</button>
					<button type="button" class="btn bg-orange btn-flat bigbtn" @click="addNewExchange" v-if="list_menu_add">添加兑换</button>
				</div>
			</div>
			<div class="table-responsive">
				<table class="table table-striped table-bordered table-hover" data-pagination="true" ref="point_list"></table>
			</div>
		</div>

		<!-- 新增/修改面板 -->
		<div class="detail-pannel" v-show="showDetail">
			<h2>{{is_modify?'修改':'新增'}}兑换</h2>
			<el-form label-width="150px">
				<el-form-item label="适用门店">
					<el-input v-model="shop_name" disabled></el-input>
				</el-form-item>
				<el-form-item label="兑换商品/卡券">
					<el-input v-model="add_form.goods_name" placeholder="请选择兑换的商品/卡券" readonly @click.native="openExchangePop"></el-input>
				</el-form-item>
				<el-form-item label="可兑换总数">
					<el-radio-group v-model="add_form.limit_total">
						<el-radio label="-1">不限制</el-radio>
						<el-radio label="1">限制数量</el-radio>
					</el-radio-group>
					<el-input v-model="add_form.max_exchange_num" placeholder="请输入可兑换总数" :disabled="add_form.limit_total != '1'"></el-input>
				</el-form-item>
				<el-form-item label="每个用户可兑换数量">
					<el-radio-group v-model="add_form.limit_per_user">
						<el-radio label="-1">不限制</el-radio>
						<el-radio label="1">限制数量</el-radio>
					</el-radio-group>
					<el-input v-model="add_form.user_max_exchange_num" placeholder="请输入每个用户可兑换数量" :disabled="add_form.limit_per_user != '1'"></el-input>
				</el-form-item>
				<el-form-item label="兑换积分">
					<el-input v-model="add_form.points" placeholder="请输入兑换积分"></el-input>
				</el-form-item>
				<el-form-item label="消费者端是否显示">
					<el-select v-model="add_form.customer_show" placeholder="请选择">
					    <el-option label="是" value="1"></el-option>
					    <el-option label="否" value="-1"></el-option>
					</el-select>
				</el-form-item>
				<div class="sub-title">———— 不同会员等级兑换设置 ————</div>
				<div class="gray-block">
					<el-checkbox v-model="vip_level_check_all" @change="onAllLevelCheckChange">全选<span class="red-tip">注：1 未勾选的会员等级，则表示该等级会员不可兑换该商品/卡券；2 对应等级未单独设置积分时，则默认使用上面设置的统一兑换积分</span></el-checkbox>
					<div class="item">
			    		<el-checkbox v-model="vip_level_1_check">一级会员卡兑换积分</el-checkbox>
						<el-input v-model="add_form.vip_level_1_points" placeholder="请输入兑换积分" :disabled="!vip_level_1_check"></el-input>
					</div>
					<div class="item">
			    		<el-checkbox v-model="vip_level_2_check">二级会员卡兑换积分</el-checkbox>
						<el-input v-model="add_form.vip_level_2_points" placeholder="请输入兑换积分" :disabled="!vip_level_2_check"></el-input>
					</div>
					<div class="item">
			    		<el-checkbox v-model="vip_level_3_check">三级会员卡兑换积分</el-checkbox>
						<el-input v-model="add_form.vip_level_3_points" placeholder="请输入兑换积分" :disabled="!vip_level_3_check"></el-input>
					</div>
					<div class="item">
			    		<el-checkbox v-model="vip_level_4_check">四级会员卡兑换积分</el-checkbox>
						<el-input v-model="add_form.vip_level_4_points" placeholder="请输入兑换积分" :disabled="!vip_level_4_check"></el-input>
					</div>
					<div class="item">
			    		<el-checkbox v-model="vip_level_5_check">五级会员卡兑换积分</el-checkbox>
						<el-input v-model="add_form.vip_level_5_points" placeholder="请输入兑换积分" :disabled="!vip_level_5_check"></el-input>
					</div>
					<div class="item">
			    		<el-checkbox v-model="vip_level_6_check">六级会员卡兑换积分</el-checkbox>
						<el-input v-model="add_form.vip_level_6_points" placeholder="请输入兑换积分" :disabled="!vip_level_6_check"></el-input>
					</div>
					<div class="item">
			    		<el-checkbox v-model="vip_level_7_check">七级会员卡兑换积分</el-checkbox>
						<el-input v-model="add_form.vip_level_7_points" placeholder="请输入兑换积分" :disabled="!vip_level_7_check"></el-input>
					</div>
					<div class="item">
			    		<el-checkbox v-model="vip_level_8_check">八级会员卡兑换积分</el-checkbox>
						<el-input v-model="add_form.vip_level_8_points" placeholder="请输入兑换积分" :disabled="!vip_level_8_check"></el-input>
					</div>
					<div class="item">
			    		<el-checkbox v-model="vip_level_9_check">九级会员卡兑换积分</el-checkbox>
						<el-input v-model="add_form.vip_level_9_points" placeholder="请输入兑换积分" :disabled="!vip_level_9_check"></el-input>
					</div>
					<div class="item">
			    		<el-checkbox v-model="vip_level_10_check">十级会员卡兑换积分</el-checkbox>
						<el-input v-model="add_form.vip_level_10_points" placeholder="请输入兑换积分" :disabled="!vip_level_10_check"></el-input>
					</div>
				</div>
				<el-form-item>
					<el-button @click="showDetail=false">返回</el-button>
					<el-button type="primary" @click="onSubmitClick">确认</el-button>
				</el-form-item>
			</el-form>
			<div class="holiday-wrapper">
				<div class="holiday-title">节假日兑换规则</div>
				<el-button type="primary" size="small" @click="addNewHolidayPoints">新增</el-button>
				<el-table
					class="holiday-table"
	                :data="holiday_list"
	                :key="holiday_key">
	                <el-table-column prop="name" label="节假日名称"></el-table-column>
	                <el-table-column label="适用日期" width="400">
						<template slot-scope="scope">{{scope.row.start_time+'~'+scope.row.end_time}}</template>
	                </el-table-column>
	                <el-table-column prop="points" label="兑换积分"></el-table-column>
	                <el-table-column label="操作">
						<template slot-scope="scope">
							<span class="text-blue" @click="editHoliday(scope.row, scope.$index)">修改</span>
							<span class="text-blue" @click="delHoliday(scope.row.name, scope.$index)">删除</span>
						</template>
	                </el-table-column>
	            </el-table>
			</div>
		</div>
		<!-- 兑换详情弹窗 -->
		<div class="exchange-pop ele-hide" ref="exchange_pop">
			<el-form :inline="true">
				<el-select v-model="pop_form.type" placeholder="请选择" @change="onPopTypeChange">
					<el-option label="商品/商品套餐" value="1"></el-option>
					<el-option label="卡券" value="2"></el-option>
				</el-select>
				<el-select v-model="pop_form.goods_type_name" filterable clearable placeholder="商品类型" v-if="pop_form.type=='1'" @change="onPopTypeNameChange">
					<el-option :label="item.text" :value="item.id" v-for="item in point_good_type"></el-option>
				</el-select>
				<el-select v-model="pop_form.goods_type_name" filterable clearable placeholder="卡券类型" v-if="pop_form.type=='2'" @change="onPopQueryClick">
					<el-option :label="item.text" :value="item.id" v-for="item in card_type"></el-option>
				</el-select>
				<el-input v-model="pop_form.goods_name" clearable :placeholder="pop_form.type=='1'?'请输入商品名称':'请输入卡券名称'"></el-input>
				<el-button type="primary" @click="onPopQueryClick">查询</el-button>	
			</el-form>
			<el-table
				v-loading="pop_loading"
				element-loading-text="努力加载中，请稍后..."
				element-loading-background="rgba(0, 0, 0, 0.6)"
				ref="pop_table"
				:data="pop_list"
				@select="onPopGoodSelect">
				<el-table-column type="selection"></el-table-column>
				<el-table-column prop="goods_type_name" label="类型"></el-table-column>
				<el-table-column prop="goods_name" label="名称"></el-table-column>
				<el-table-column prop="goods_unit_name" label="单位"></el-table-column>
			</el-table>
			<el-pagination
				background
				layout="total, prev, pager, next, jumper"
				:page-size="pop_page_size"
				:current-page.sync="pop_page"
				:total="pop_total"
				@current-change="getPopList">
			</el-pagination>
		</div>

		<!-- 节假日积分设置弹窗 -->
		<div class="holiday-pop ele-hide" ref="holiday_pop">
			<el-form :inline="true" label-width="150px">
				<el-form-item label="节假日名称" required>
					<el-input v-model="holiday_add_form.name" placeholder="请输入节假日名称"></el-input>
				</el-form-item>
				<el-form-item label="适用日期" required>
					<div class="holiday-time" ref="holiday_time">
						<el-input v-model="holiday_add_form.timeStr" placeholder="请选择适用日期" readonly></el-input>
					</div>
				</el-form-item>
				<el-form-item label="兑换积分" required>
					<el-input v-model="holiday_add_form.points" placeholder="请输入兑换积分"></el-input>
				</el-form-item>
				<div class="pop-block-title">—— 不同会员等级会员卡兑换积分设置 ——</div>
				<el-form-item label="一级会员卡兑换积分">
					<el-input v-model="holiday_add_form.vip_level_1_points" placeholder="请输入兑换积分"></el-input>	
				</el-form-item>
				<el-form-item label="二级会员卡兑换积分">
					<el-input v-model="holiday_add_form.vip_level_2_points" placeholder="请输入兑换积分"></el-input>	
				</el-form-item>
				<el-form-item label="三级会员卡兑换积分">
					<el-input v-model="holiday_add_form.vip_level_3_points" placeholder="请输入兑换积分"></el-input>	
				</el-form-item>
				<el-form-item label="四级会员卡兑换积分">
					<el-input v-model="holiday_add_form.vip_level_4_points" placeholder="请输入兑换积分"></el-input>	
				</el-form-item>
				<el-form-item label="五级会员卡兑换积分">
					<el-input v-model="holiday_add_form.vip_level_5_points" placeholder="请输入兑换积分"></el-input>	
				</el-form-item>
				<el-form-item label="六级会员卡兑换积分">
					<el-input v-model="holiday_add_form.vip_level_6_points" placeholder="请输入兑换积分"></el-input>	
				</el-form-item>
				<el-form-item label="七级会员卡兑换积分">
					<el-input v-model="holiday_add_form.vip_level_7_points" placeholder="请输入兑换积分"></el-input>	
				</el-form-item>
				<el-form-item label="八级会员卡兑换积分">
					<el-input v-model="holiday_add_form.vip_level_8_points" placeholder="请输入兑换积分"></el-input>	
				</el-form-item>
				<el-form-item label="九级会员卡兑换积分">
					<el-input v-model="holiday_add_form.vip_level_9_points" placeholder="请输入兑换积分"></el-input>	
				</el-form-item>
				<el-form-item label="十级会员卡兑换积分">
					<el-input v-model="holiday_add_form.vip_level_10_points" placeholder="请输入兑换积分"></el-input>	
				</el-form-item>
			</el-form>
		</div>
	</div>
</template>

<script>
	import Vue from 'vue';
	export default {
		data() {
			return {
				list_menu_add: false,
            	list_menu_op: [],
				add_shop_data: [],
				search_type_list: [{
					id: ' ',
					text: '全部'
				}, {
					id: '1',
					text: '商品类型'
				}, {
					id: '2',
					text: '卡券类型'
				}],
				search_type: '',
				card_type: [{
					id: ' ',
					text: '全部'
				}, {
					id: '1',
					text: '优惠券'
				}, {
					id: '2',
					text: '物品券'
				}, {
					id: '3',
					text: '商品套餐券'
				}, {
					id: '4',
					text: '开房套餐券'
				}],
				search_goods_type: '',
				search_goods_name: '',
				list_goods_type: [],
				showDetail: false,
				shop_name: '',
				add_form: {
					id: '', // 记录id，修改的时候传，新增传空
		            shop_id: '', // 门店id
		            type: '', // 兑换类型，1：商品，2：卡券
					limit_total: '-1', // 可兑换总数，-1：不限制，1：限制数量
					max_exchange_num: '', // 可兑换总数，限制数量时必填
					limit_per_user: '-1', // 每个用户可兑换数量，-1：不限制，1：限制数量
					user_max_exchange_num: '', // 每个用户可兑换数量，限制数量时必填
		            points: '', // 兑换积分
		            customer_show: '1', // 消费者端是否显示，1：是，-1：否
		            goods_id: '', // 商品id
		            goods_name: '', // 商品名称
		            goods_type: '', // 商品类型
		            goods_type_name: '', // 商品类型
		            goods_unit: '', // 商品单位
		            goods_unit_name: '', // 商品单位
		            vip_level_1_points: '', // 1级会员兑换积分，没勾选不要传
		            vip_level_2_points: '', // 2级会员兑换积分，没勾选不要传
		            vip_level_3_points: '', // 3级会员兑换积分，没勾选不要传
		            vip_level_4_points: '', // 4级会员兑换积分，没勾选不要传
		            vip_level_5_points: '', // 5级会员兑换积分，没勾选不要传
		            vip_level_6_points: '', // 6级会员兑换积分，没勾选不要传
		            vip_level_7_points: '', // 7级会员兑换积分，没勾选不要传
		            vip_level_8_points: '', // 8级会员兑换积分，没勾选不要传
		            vip_level_9_points: '', // 9级会员兑换积分，没勾选不要传
		            vip_level_10_points: '', // 10级会员兑换积分，没勾选不要传
		            rule_info: []
				},
				is_modify: false, // 是否是修改
				vip_level_check_all: true, // 会员等级积分全选
				vip_level_1_check: true,
				vip_level_2_check: true,
				vip_level_3_check: true,
				vip_level_4_check: true,
				vip_level_5_check: true,
				vip_level_6_check: true,
				vip_level_7_check: true,
				vip_level_8_check: true,
				vip_level_9_check: true,
				vip_level_10_check: true,
				holiday_list: [],

				pop_form: {
					type: '1', // 1商品套餐  2卡券
					goods_type_name: ' ', // 类型名称
					goods_name: '',
				},
				pop_loading: false,
				pop_page: 1,
				pop_page_size: 5,
				pop_total: 0,
				pop_list: [],
				choosedGood: {}, // 选择的商品
				point_good_type: [],

				holiday_add_form: {
					id: '',
					name: '',
					points: '',
					start_time: '',
					end_time: '',
					timeStr: '',
					vip_level_1_points: '',
					vip_level_2_points: '',
					vip_level_3_points: '',
					vip_level_4_points: '',
					vip_level_5_points: '',
					vip_level_6_points: '',
					vip_level_7_points: '',
					vip_level_8_points: '',
					vip_level_9_points: '',
					vip_level_10_points: '',
				},
				holiday_key: Math.random(),
			}
		},
		watch: {
			search_type: function(val, oldVal) {
				let _this = this
				let search_goods_type_select_option = {}
				if (val == ' ') {
					search_goods_type_select_option = {
						data: [],
						disabled: true,
						allowClear: true,
						minimumResultsForSearch: -1,
						language: "zh-CN"
					}
				}else if (val == '1') { // 商品
					search_goods_type_select_option = {
						data: _this.list_goods_type,
						disabled: false,
						allowClear: true,
						minimumResultsForSearch: -1,
						language: "zh-CN"
					}
				}else if (val == '2') { // 卡券
					search_goods_type_select_option = {
						data: _this.card_type,
						disabled: false,
						allowClear: true,
						minimumResultsForSearch: -1,
						language: "zh-CN"
					}
				}
				_this.search_goods_type = ''
				$(_this.$refs.search_goods_type).html("");
				$(_this.$refs.search_goods_type).select2(search_goods_type_select_option)
				.on("select2:select", function(e) {
					_this.search_goods_type = e.params.data.id == ' ' ? '' : e.params.data.id 
				});
			},
			vip_level_1_check: function(val) {
				if (val) {
					this.vip_level_check_all = this.judgeIsAll()
				}else {
					this.vip_level_check_all = false
				}
			},
			vip_level_2_check: function(val) {
				if (val) {
					this.vip_level_check_all = this.judgeIsAll()
				}else {
					this.vip_level_check_all = false
				}
			},
			vip_level_3_check: function(val) {
				if (val) {
					this.vip_level_check_all = this.judgeIsAll()
				}else {
					this.vip_level_check_all = false
				}
			},
			vip_level_4_check: function(val) {
				if (val) {
					this.vip_level_check_all = this.judgeIsAll()
				}else {
					this.vip_level_check_all = false
				}
			},
			vip_level_5_check: function(val) {
				if (val) {
					this.vip_level_check_all = this.judgeIsAll()
				}else {
					this.vip_level_check_all = false
				}
			},
			vip_level_6_check: function(val) {
				if (val) {
					this.vip_level_check_all = this.judgeIsAll()
				}else {
					this.vip_level_check_all = false
				}
			},
			vip_level_7_check: function(val) {
				if (val) {
					this.vip_level_check_all = this.judgeIsAll()
				}else {
					this.vip_level_check_all = false
				}
			},
			vip_level_8_check: function(val) {
				if (val) {
					this.vip_level_check_all = this.judgeIsAll()
				}else {
					this.vip_level_check_all = false
				}
			},
			vip_level_9_check: function(val) {
				if (val) {
					this.vip_level_check_all = this.judgeIsAll()
				}else {
					this.vip_level_check_all = false
				}
			},
			vip_level_10_check: function(val) {
				if (val) {
					this.vip_level_check_all = this.judgeIsAll()
				}else {
					this.vip_level_check_all = false
				}
			},
		},
		mounted: function() {
			this.getMenuOp();
			this.$nextTick(function() {
				this.getShopData();
				this.getCusPakage();
			});
		},
		methods: {
			// 获取权限
			getMenuOp() {
				let _this = this,
					menu = [];
				if(!$.isEmptyObject(this.$store.state.menunew)) {
					menu = JSON.parse(this.$store.state.menunew);
					$.each(menu, function(k, v) {
						if(v.id == '542') {
							menu = v.submenu;
							$.each(menu, function(m, n) {
								if(n.id == '652') {
									menu = n.submenu;
								}
							});
						}
					});

					_this.list_menu_op = [];
					$.each(menu, function(x, y) {
						if(y.id == '936') {
							_this.list_menu_add = true;
						}
						if(y.id == '937') {
							_this.list_menu_op.push({cls: 'text-blue edit', name: '修改'});
						}
						if(y.id == '938') {
							_this.list_menu_op.push({cls: 'text-blue del', name: '删除'});
						}
					});
				}
			},
			// 获取门店数据
			getShopData: function() {
				let _this = this;

				let shopDatas = [];
				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);
				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "PublicData/api_getShopListByPurview",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
					data: {
						json: datas2
					},
					success: function(data) {
						if(data.response.result_code == "true") {
							$.each(data.response.result, function(k, v) {
								shopDatas.push({ id: v.id, text: v.name });
							});
							shopDatas.shift();
							$(_this.$refs.shop).select2({
								data: shopDatas,
								allowClear: true,
								minimumResultsForSearch: -1,
								language: "zh-CN"
							});
							_this.innitTable();

							_this.add_shop_data = shopDatas;
							// $(_this.$refs.point_good_shop).html("");
							// $(_this.$refs.point_good_shop).select2({
							// 	data: _this.add_shop_data,
							// 	minimumResultsForSearch: -1,
							// 	language: "zh-CN",
							// 	width: '100%'
							// }).on("select2:select", function(e) {
							// 	_this.pointQueryGoods();
							// });
						} else {
							Vue.timeoutfun(data.response.result_status,_this);
							layer.msg(data.response.data.error_msg);
						}
					},
					error: function(err) {
						layer.msg("网络错误");
					}
				});
			},
			// 初始化类型下拉检索条件
			innitSearchDoubleSelect() {
				let _this =  this
				$(_this.$refs.search_type).select2({
					data: _this.search_type_list,
					minimumResultsForSearch: -1,
					language: "zh-CN",
				}).on("select2:select", function(e) {
					_this.search_type = e.params.data.id
				});

				$(_this.$refs.search_goods_type).prop('disabled', true);
			},
			// 查询
			clkQuery: function() {
				this.innitTable();
			},
			// 积分兑换列表
			innitTable: function() {
				let _this = this;
				$(_this.$refs.point_list).bootstrapTable("destroy");
				$(_this.$refs.point_list).bootstrapTable({
					pageNumber: 1,
					pageSize: 10,
					pageList: [],
					pagination: true,
					ajax: function(params) {
						_this.getList(params);
					},
					sidePagination: "server",
					columns: [{
						field: "type_name",
						title: "兑换类型",
						width: "10%"
					}, {
						field: "goods_type_name",
						title: "类型名称",
						width: "10%"
					}, {
						field: "goods_name",
						title: "商品/卡券名称",
						width: "15%"
					}, {
						field: "goods_unit_name",
						title: "单位",
						width: "10%"
					}, {
						field: "points",
						title: "兑换积分",
						width: "10%"
					}, {
						field: "customer_show_name",
						title: "消费者端显示",
						width: "10%"
					}, {
						field: "max_exchange_num",
						title: "可兑换总数/已兑换",
						width: "10%",
						formatter: function(value, row, index) {
							return row.max_exchange_num == '-1' ? '不限制' : row.max_exchange_num + '/' + row.exchange_num
						}
					}, {
						field: "user_max_exchange_num",
						title: "每个用户可兑换数量",
						width: "10%",
						formatter: function(value, row, index) {
							return row.user_max_exchange_num == '-1' ? '不限制' : row.user_max_exchange_num
						}
					}, {
						title: "操作",
						width: "15%",
						events: {
							'click .edit': function(e, value, row) {
								_this.onEditClick(row)
							},
							'click .del': function(e, value, row) {
								layer.confirm("删除后不可恢复，确定删除【"+ row.goods_name +"】积分兑换规则？", {
									btn: ['确定', '取消'],
								}, function() {
									_this.delPoint(row.id);
								});
							}
						},
						formatter: function(value, row, index) {
							let op_html = '';
							$.each(_this.list_menu_op, function(k, v) {
								op_html += '<span class="'+ v.cls +'">'+ v.name +'</span>&nbsp;&nbsp;';
							});
							return op_html;
						}
					}],
				});
			},
			// 表格数据
			getList: function(params) {
				let _this = this,
					shop_id = $(_this.$refs.shop).val(),
					pageNumber = 1;
				if(params != "" && params.data.offset != 0) {
					pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
				}
				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"page": pageNumber,
							"page_size": params.data.limit,
							"shop_id": shop_id,
							"type": $.trim(_this.search_type),
							"goods_type": _this.search_goods_type,
							"goods_name": _this.search_goods_name
						}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);
				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "PointsGoods/getList",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
					data: {
						json: datas2
					},
					success: function(data) {
						if(data.response.result_code == "true") {
							params.success({
								total: data.response.result.count,
								rows: data.response.result.data
							});
						} else {
							Vue.timeoutfun(data.response.result_status, _this);
							layer.msg(data.response.error_msg);
							params.success({
								total: 0,
								rows: 0
							});
						}
					},
					error: function(err) {
						layer.msg("出错啦");
					}
				});
			},

			// 点击“新增兑换”
			addNewExchange() {
				this.shop_name = $(this.$refs.shop).find("option:selected").text()
				this.add_form = {
					id: '', // 记录id，修改的时候传，新增传空
		            shop_id: $(this.$refs.shop).val(), // 门店id
		            type: '', // 兑换类型，1：商品，2：卡券
					limit_total: '-1', // 可兑换总数，-1：不限制，1：限制数量
					max_exchange_num: '', // 可兑换总数，限制数量时必填
					limit_per_user: '-1', // 每个用户可兑换数量，-1：不限制，1：限制数量
					user_max_exchange_num: '', // 每个用户可兑换数量，限制数量时必填
		            points: '', // 兑换积分
		            customer_show: '1', // 消费者端是否显示，1：是，-1：否
		            goods_id: '', // 商品id
		            goods_name: '', // 商品名称
		            goods_type: '', // 商品类型
		            goods_type_name: '', // 商品类型
		            goods_unit: '', // 商品单位
		            goods_unit_name: '', // 商品单位
		            vip_level_1_points: '', // 1级会员兑换积分，没勾选不要传
		            vip_level_2_points: '', // 2级会员兑换积分，没勾选不要传
		            vip_level_3_points: '', // 3级会员兑换积分，没勾选不要传
		            vip_level_4_points: '', // 4级会员兑换积分，没勾选不要传
		            vip_level_5_points: '', // 5级会员兑换积分，没勾选不要传
		            vip_level_6_points: '', // 6级会员兑换积分，没勾选不要传
		            vip_level_7_points: '', // 7级会员兑换积分，没勾选不要传
		            vip_level_8_points: '', // 8级会员兑换积分，没勾选不要传
		            vip_level_9_points: '', // 9级会员兑换积分，没勾选不要传
		            vip_level_10_points: '', // 10级会员兑换积分，没勾选不要传
		            rule_info: []
				},
				this.is_modify = false // 是否是修改
				this.vip_level_check_all = true // 会员等级积分全选
				this.vip_level_1_check = true
				this.vip_level_2_check = true
				this.vip_level_3_check = true
				this.vip_level_4_check = true
				this.vip_level_5_check = true
				this.vip_level_6_check = true
				this.vip_level_7_check = true
				this.vip_level_8_check = true
				this.vip_level_9_check = true
				this.vip_level_10_check = true
				this.holiday_list = []
				this.showDetail = true
			},

			// 点击列表“修改”兑换
			onEditClick(row) {
				this.shop_name = $(this.$refs.shop).find("option:selected").text()
				this.add_form = {
					id: row.id, // 记录id，修改的时候传，新增传空
		            shop_id: row.shop_id, // 门店id
		            type: row.type, // 兑换类型，1：商品，2：卡券
					limit_total: row.max_exchange_num == '-1' ? '-1' : '1', // 可兑换总数，-1：不限制，1：限制数量
					max_exchange_num: row.max_exchange_num == '-1' ? '' : row.max_exchange_num, // 可兑换总数，限制数量时必填
					limit_per_user: row.user_max_exchange_num == '-1' ? '-1' : '1', // 每个用户可兑换数量，-1：不限制，1：限制数量
					user_max_exchange_num: row.user_max_exchange_num == '-1' ? '' : row.user_max_exchange_num, // 每个用户可兑换数量，限制数量时必填
		            points: row.points, // 兑换积分
		            customer_show: row.customer_show, // 消费者端是否显示，1：是，-1：否
		            goods_id: row.goods_id, // 商品id
		            goods_name: row.goods_name, // 商品名称
		            goods_type: row.goods_type, // 商品类型
		            goods_type_name: row.goods_type_name, // 商品类型
		            goods_unit: row.goods_unit, // 商品单位
		            goods_unit_name: row.goods_unit_name, // 商品单位
		            vip_level_1_points: row.vip_level_1_points == '-1' ? '' : row.vip_level_1_points, // 1级会员兑换积分，没勾选不要传
		            vip_level_2_points: row.vip_level_2_points == '-1' ? '' : row.vip_level_2_points, // 2级会员兑换积分，没勾选不要传
		            vip_level_3_points: row.vip_level_3_points == '-1' ? '' : row.vip_level_3_points, // 3级会员兑换积分，没勾选不要传
		            vip_level_4_points: row.vip_level_4_points == '-1' ? '' : row.vip_level_4_points, // 4级会员兑换积分，没勾选不要传
		            vip_level_5_points: row.vip_level_5_points == '-1' ? '' : row.vip_level_5_points, // 5级会员兑换积分，没勾选不要传
		            vip_level_6_points: row.vip_level_6_points == '-1' ? '' : row.vip_level_6_points, // 6级会员兑换积分，没勾选不要传
		            vip_level_7_points: row.vip_level_7_points == '-1' ? '' : row.vip_level_7_points, // 7级会员兑换积分，没勾选不要传
		            vip_level_8_points: row.vip_level_8_points == '-1' ? '' : row.vip_level_8_points, // 8级会员兑换积分，没勾选不要传
		            vip_level_9_points: row.vip_level_9_points == '-1' ? '' : row.vip_level_9_points, // 9级会员兑换积分，没勾选不要传
		            vip_level_10_points: row.vip_level_10_points == '-1' ? '' : row.vip_level_10_points, // 10级会员兑换积分，没勾选不要传
		            rule_info: row.rule_info
				},
				this.vip_level_1_check = row.vip_level_1_points == '-1' ? false : true
				this.vip_level_2_check = row.vip_level_2_points == '-1' ? false : true
				this.vip_level_3_check = row.vip_level_3_points == '-1' ? false : true
				this.vip_level_4_check = row.vip_level_4_points == '-1' ? false : true
				this.vip_level_5_check = row.vip_level_5_points == '-1' ? false : true
				this.vip_level_6_check = row.vip_level_6_points == '-1' ? false : true
				this.vip_level_7_check = row.vip_level_7_points == '-1' ? false : true
				this.vip_level_8_check = row.vip_level_8_points == '-1' ? false : true
				this.vip_level_9_check = row.vip_level_9_points == '-1' ? false : true
				this.vip_level_10_check = row.vip_level_10_points == '-1' ? false : true
				this.is_modify = true // 是否是修改
				this.holiday_list = row.rule_info
				this.showDetail = true
			},

			// 打开“兑换详情弹窗”
			openExchangePop() {
				let _this = this
				_this.pop_form = {
					type: '1', // 1商品套餐  2卡券
					goods_type_name: ' ', // 类型名称
					goods_name: '',
				},
				
				layer.confirm('', {
					skin: 'public-alert-skin',
					type: 1,
					btn: ['保存', '取消'],
					title: ['兑换详情', true],
					area: ['780px', '580px'],
					content: $(_this.$refs.exchange_pop),
					offset: '100px'
				}, function() {
					if (!_this.choosedGood.goods_name) {
						layer.msg("请先选择要兑换的商品/卡券")
						return
					}
					_this.add_form.type = _this.pop_form.type
					_this.add_form.goods_id = _this.choosedGood.id || _this.choosedGood.goods_id // 商品id
		            _this.add_form.goods_name = _this.choosedGood.goods_name // 商品名称
		            _this.add_form.goods_type = _this.choosedGood.goods_type // 商品类型
		            _this.add_form.goods_type_name = _this.choosedGood.goods_type_name // 商品类型
		            _this.add_form.goods_unit = _this.choosedGood.goods_unit  // 商品单位
		            _this.add_form.goods_unit_name = _this.choosedGood.goods_unit_name // 商品单位
		            layer.closeAll()
				});

				_this.$nextTick(() => {
					_this.getPointGoodsList(1)
				})
			},

			// 弹窗类型变化
			onPopTypeChange(val) {
				this.pop_form.goods_type_name = ' '
				if (val == '1') {
					this.getPointGoodsList(1)
				}else {
					this.getPointCardList(1)
				}
			},

			// 弹窗类型名称变化
			onPopTypeNameChange(val) {
				if (val.includes("package")) { // 商品套餐
					this.getPointGoodsPackageList(1)
				}else {
					this.getPointGoodsList(1)
				}
			},

			// 获取弹窗列表
			getPopList(page) {
				if (this.pop_form.type == '1') {
					if (this.pop_form.goods_type_name.includes("package")) { // 商品套餐
						this.getPointGoodsPackageList(page)
					}else {
						this.getPointGoodsList(page)
					}
				}else {
					this.getPointCardList(page)
				}
			},

			// 点击兑换弹窗“查询”
			onPopQueryClick() {
				this.getPopList(1)
			},

			// 选择弹窗表格某一项
			onPopGoodSelect(val, row) {
				this.$refs.pop_table.clearSelection()
            	this.$refs.pop_table.toggleRowSelection(row, true)
            	this.choosedGood = row
			},

			// 获取商品类型
			getCusPakage() {
				const _this = this;

				_this.list_goods_type = [{ id: " ", text: "全部" }, { id: "0", text: "商品套餐" }];
				_this.point_good_type = [{
					id: " ",
					text: "全部"
				}, {
					id: "package0",
					text: "商品套餐",
				}];
				Vue.axios.post('PublicData/api_getWaresType', {
					"header": Vue.request_header,
					"request": {
						"param": {}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						res.data.response.result.data.forEach(v => {
							_this.list_goods_type.push({
								id: 'package' + v.id,
								text: v.name
							});
						});
						res.data.response.result.data.forEach(v => {
							_this.point_good_type.push({
								id: 'package' + v.id,
								text: v.name,
							});
						});
						_this.innitPointSelect();
						// _this.innitSearchDoubleSelect()
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg('出错啦');
				});
			},
			innitPointSelect: function() {
				let _this = this;
				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);

				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "PublicData/api_getGoodsType",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
					data: {
						json: datas2
					},
					success: function(data) {
						if(data.response.result_code == "true") {
							$.each(data.response.result.data, function(k, v) {
								_this.list_goods_type.push({
									id: v.id,
									text: v.name
								});
								_this.point_good_type.push({
									id: v.id,
									text: v.name
								});
							});
							_this.innitSearchDoubleSelect()
							// $.each(data.response.result.data, function(k, v) {
							// 	_this.point_good_type.push({
							// 		id: v.id,
							// 		text: v.name
							// 	});
							// });
							// $(_this.$refs.point_type).select2({
							// 	data: _this.list_goods_type,
							// 	allowClear: true,
							// 	minimumResultsForSearch: -1,
							// 	language: "zh-CN"
							// });
							// $(_this.$refs.point_good_type).select2({
							// 	data: _this.point_good_type,
							// 	width: '100%'
							// }).on("select2:select", function(e) {
							// 	_this.point_sign = e.params.data.sign;
							// 	if(_this.point_sign == '-2') {
							// 		_this.point_sign_id = e.params.data.sign_id;
							// 		_this.innitPointGoodsPackageTable();
							// 	} else {
							// 		_this.innitPointGoodTable();
							// 	}
							// });
						} else {
							Vue.timeoutfun(data.response.result_status, _this);
							layer.msg(data.response.error_msg);
						}
					},
					error: function(err) {
						layer.msg("出错啦");
					}
				});
			},
			
			// 获取商品列表
			getPointGoodsList: function(page) {
				let _this = this
				_this.pop_loading = true
				_this.pop_page = page
				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"page": page,
							"page_size": _this.pop_page_size,
							"shop_id": $(_this.$refs.shop).val(),
							"goods_type": $.trim(_this.pop_form.goods_type_name),
							"goods_name": _this.pop_form.goods_name
						}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);
				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "merchantGoods/searchMerchantGoodsList",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
					data: {
						json: datas2
					},
					success: function(data) {
						if(data.response.result_code == "true") {
							if(page == 1) {
								_this.pop_total = Number(data.response.result.data.total);
							}
							_this.pop_list = data.response.result.data.rows;
							_this.pop_loading = false;
						} else {
							Vue.timeoutfun(data.response.result_status,_this);
							layer.msg(data.response.error_msg);
						}
					},
					error: function(err) {
						layer.msg("出错啦");
					}
				});
			},
			
			// 获取商品套餐列表
			getPointGoodsPackageList: function(page) {
				let _this = this
				let goods_type = $.trim(_this.pop_form.goods_type_name)
				if (goods_type.includes("package")) {
					goods_type = goods_type.split("package")[1]
				}
				_this.pop_loading = true
				_this.pop_page = page


				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"page": page,
							"page_size": _this.pop_page_size,
							"shop_id": $(_this.$refs.shop).val(),
							"goods_type": goods_type,
							"goods_name": _this.pop_form.goods_name,
							"api_from": 'point_goods'
						}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);

				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "merchantGoods/searchMerchantGoodsPackage",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
					data: {
						json: datas2
					},
					success: function(data) {
						if(data.response.result_code == "true") {
							if(page == 1) {
								_this.pop_total = Number(data.response.result.data.total);
							}
							data.response.result.data.rows.forEach(item => {
								item.goods_name = item.name
								item.goods_unit = item.package_unit
								item.goods_unit_name = item.package_unit_name
							})
							_this.pop_list = data.response.result.data.rows;
							_this.pop_loading = false;
						} else {
							Vue.timeoutfun(data.response.result_status,_this);
							layer.msg(data.response.error_msg);
						}
					},
					error: function(err) {
						layer.msg("出错啦");
					}
				});
			},
			// 获取卡券列表
			getPointCardList: function(page) {
				let _this = this
				_this.pop_loading = true
				_this.pop_page = page
				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"page": page,
							"page_size": _this.pop_page_size,
							"shop_id": $(_this.$refs.shop).val(),
							"type": $.trim(_this.pop_form.goods_type_name),
							"name": _this.pop_form.goods_name
						}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);
				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "MerchantGift/getList",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
					data: {
						json: datas2
					},
					success: function(data) {
						if(data.response.result_code == "true") {
							if(page == 1) {
								_this.pop_total = Number(data.response.result.count);
							}
							_this.pop_list = data.response.result.data;
							_this.pop_loading = false;
						} else {
							Vue.timeoutfun(data.response.result_status,_this);
							layer.msg(data.response.error_msg);
						}
					},
					error: function(err) {
						layer.msg("出错啦");
					}
				});
			},
			
			// 删除商品
			delPoint: function(id) {
				let _this = this;
				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"id": id
						}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);
				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "PointsGoods/delete",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
					data: {
						json: datas2
					},
					success: function(data) {
						if(data.response.result_code == "true") {
							layer.msg(data.response.error_msg);
							$(_this.$refs.point_list).bootstrapTable("refresh");
						} else {
							Vue.timeoutfun(data.response.result_status, _this);
							layer.msg(data.response.error_msg);
						}
					},
					error: function(err) {
						layer.msg("出错啦");
					}
				});
			},

			// 全部会员等级选择
			onAllLevelCheckChange(val) {
				if (val) {
					for (var i = 1; i <= 10; i++) {
						this[`vip_level_${i}_check`] = true
					}
				}else {
					for (var i = 1; i <= 10; i++) {
						this[`vip_level_${i}_check`] = false
					}
				}
			},

			// 判断是否全选
			judgeIsAll() {
				let count = 0
				for (var i = 1; i <= 10; i++) {
					if(this[`vip_level_${i}_check`]) {
						count ++
					}
				}
				return count == 10 ? true : false 
			},

			// 点击“新增”节假日兑换积分设置
			addNewHolidayPoints() {
				let _this = this 
				_this.holiday_add_form = {
					id: '',
					name: '',
					points: '',
					start_time: '',
					end_time: '',
					timeStr: '',
					vip_level_1_points: '',
					vip_level_2_points: '',
					vip_level_3_points: '',
					vip_level_4_points: '',
					vip_level_5_points: '',
					vip_level_6_points: '',
					vip_level_7_points: '',
					vip_level_8_points: '',
					vip_level_9_points: '',
					vip_level_10_points: '',
				}
				// this.holiday_vip_level_1_check = true
				// this.holiday_vip_level_2_check = true
				// this.holiday_vip_level_3_check = true
				// this.holiday_vip_level_4_check = true
				// this.holiday_vip_level_5_check = true
				// this.holiday_vip_level_6_check = true
				// this.holiday_vip_level_7_check = true
				// this.holiday_vip_level_8_check = true
				// this.holiday_vip_level_9_check = true
				// this.holiday_vip_level_10_check = true

				layer.confirm('', {
                    skin: 'public-alert-skin',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['节假日兑换规则', true],
                    area: ['960px', '550px'], // 宽高
                    content: $(_this.$refs.holiday_pop),
                }, function() {
                	if (_this.holiday_add_form.name == '') {
                		layer.msg("请先输入节假日名称")
                		return
                	}
                	if (_this.holiday_add_form.start_time == '') {
                		layer.msg("请先选择适用日期")
                		return
                	}
                	if (_this.holiday_add_form.points == '') {
                		layer.msg("请先输入兑换积分")
                		return
                	}

                	let obj = {
                		id: '',
						name: _this.holiday_add_form.name,
						points: _this.holiday_add_form.points,
						start_time: _this.holiday_add_form.start_time,
						end_time: _this.holiday_add_form.end_time,
						timeStr: _this.holiday_add_form.timeStr,
                	}
                	for (var i = 1; i <= 10; i++) { // 会员兑换积分，没勾选不要传
						// if (_this[`holiday_vip_level_${i}_check`]) {
							obj[`vip_level_${i}_points`] = _this.holiday_add_form[`vip_level_${i}_points`]
						// }
					}
                	_this.holiday_list.push(obj)
                	_this.holiday_key = Math.random()
                	layer.closeAll()
                });

                _this.$nextTick(() => {
                	_this.innitHolidayDate()
                })
			},

			// 初始化节假日价格设置弹窗日期插件
            innitHolidayDate: function() {
                let _this = this;
                $(_this.$refs.holiday_time).daterangepicker({
                    buttonClasses: ['btn btn-default'],
                    applyClass: 'btn-small btn-orange',
                    cancelClass: 'btn-small btn-gray',
                    startDate: moment().toDate(),
                    endDate: moment().add(1, 'day').toDate(),
                }, function(start, end, label) {
                    _this.holiday_add_form.start_time = start.format('YYYY-MM-DD HH:mm');
                    _this.holiday_add_form.end_time = end.format('YYYY-MM-DD HH:mm');
                    _this.holiday_add_form.timeStr = _this.holiday_add_form.start_time + '~' + _this.holiday_add_form.end_time
                });
            },

			// 点击确认
			onSubmitClick() {
				let _this = this
				let params = {
					id: _this.add_form.id, // 记录id，修改的时候传，新增传空
		            shop_id:_this.add_form.shop_id, // 门店id
		            type: _this.add_form.type, // 兑换类型，1：商品，2：卡券
					max_exchange_num: _this.add_form.limit_total == '-1' ? '-1' : _this.add_form.max_exchange_num, // 可兑换总数，限制数量时必填
					user_max_exchange_num: _this.add_form.limit_per_user == '-1' ? '-1' : _this.add_form.user_max_exchange_num, // 每个用户可兑换数量，限制数量时必填
		            points: _this.add_form.points, // 兑换积分
		            customer_show: _this.add_form.customer_show, // 消费者端是否显示，1：是，-1：否
		            goods_id: _this.add_form.goods_id, // 商品id
		            goods_name: _this.add_form.goods_name, // 商品名称
		            goods_type: _this.add_form.goods_type, // 商品类型
		            goods_type_name: _this.add_form.goods_type_name, // 商品类型
		            goods_unit: _this.add_form.goods_unit, // 商品单位
		            goods_unit_name: _this.add_form.goods_unit_name, // 商品单位
		            rule_info: _this.holiday_list
				}
				for (var i = 1; i <= 10; i++) { // 会员兑换积分，没勾选不要传
					if (this[`vip_level_${i}_check`]) {
						params[`vip_level_${i}_points`] = _this.add_form[`vip_level_${i}_points`]
					}
				}
				Vue.axios.post('PointsGoods/edit', {
					"header": Vue.request_header,
					"request": {
						"param": params
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						if (_this.is_modify) {
							layer.msg("修改成功！")
						}else {
							layer.msg("新增成功！")
						}
						_this.showDetail = false
						$(_this.$refs.point_list).bootstrapTable("refresh");
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg('出错啦');
				});
			},

			editHoliday(row, index) {
				let _this = this 
				_this.holiday_add_form = {
					id: row.id,
					name: row.name,
					points: row.points,
					start_time: row.start_time,
					end_time: row.end_time,
					timeStr: row.start_time + '~' + row.end_time,
					vip_level_1_points: row.vip_level_1_points == '-1' ? '' : row.vip_level_1_points,
					vip_level_2_points: row.vip_level_2_points == '-1' ? '' : row.vip_level_2_points,
					vip_level_3_points: row.vip_level_3_points == '-1' ? '' : row.vip_level_3_points,
					vip_level_4_points: row.vip_level_4_points == '-1' ? '' : row.vip_level_4_points,
					vip_level_5_points: row.vip_level_5_points == '-1' ? '' : row.vip_level_5_points,
					vip_level_6_points: row.vip_level_6_points == '-1' ? '' : row.vip_level_6_points,
					vip_level_7_points: row.vip_level_7_points == '-1' ? '' : row.vip_level_7_points,
					vip_level_8_points: row.vip_level_8_points == '-1' ? '' : row.vip_level_8_points,
					vip_level_9_points: row.vip_level_9_points == '-1' ? '' : row.vip_level_9_points,
					vip_level_10_points: row.vip_level_10_points == '-1' ? '' : row.vip_level_10_points,
				}
				// this.holiday_vip_level_1_check = (typeof(row.vip_level_1_points) != "undefined" && row.vip_level_1_points != '-1')
				// this.holiday_vip_level_2_check = (typeof(row.vip_level_2_points) != "undefined" && row.vip_level_2_points != '-1')
				// this.holiday_vip_level_3_check = (typeof(row.vip_level_3_points) != "undefined" && row.vip_level_3_points != '-1')
				// this.holiday_vip_level_4_check = (typeof(row.vip_level_4_points) != "undefined" && row.vip_level_4_points != '-1')
				// this.holiday_vip_level_5_check = (typeof(row.vip_level_5_points) != "undefined" && row.vip_level_5_points != '-1')
				// this.holiday_vip_level_6_check = (typeof(row.vip_level_6_points) != "undefined" && row.vip_level_6_points != '-1')
				// this.holiday_vip_level_7_check = (typeof(row.vip_level_7_points) != "undefined" && row.vip_level_7_points != '-1')
				// this.holiday_vip_level_8_check = (typeof(row.vip_level_8_points) != "undefined" && row.vip_level_8_points != '-1')
				// this.holiday_vip_level_9_check = (typeof(row.vip_level_9_points) != "undefined" && row.vip_level_9_points != '-1')
				// this.holiday_vip_level_10_check = (typeof(row.vip_level_10_points) != "undefined" && row.vip_level_10_points != '-1')

				layer.confirm('', {
                    skin: 'public-alert-skin',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['节假日兑换规则', true],
                    area: ['960px', '550px'], // 宽高
                    content: $(_this.$refs.holiday_pop),
                }, function() {
                	if (_this.holiday_add_form.name == '') {
                		layer.msg("请先输入节假日名称")
                		return
                	}
                	if (_this.holiday_add_form.start_time == '') {
                		layer.msg("请先选择适用日期")
                		return
                	}
                	if (_this.holiday_add_form.points == '') {
                		layer.msg("请先输入兑换积分")
                		return
                	}

                	let obj = {
                		id: _this.holiday_add_form.id,
						name: _this.holiday_add_form.name,
						points: _this.holiday_add_form.points,
						start_time: _this.holiday_add_form.start_time,
						end_time: _this.holiday_add_form.end_time,
						timeStr: _this.holiday_add_form.start_time + '~' + _this.holiday_add_form.end_time,
                	}
                	for (var i = 1; i <= 10; i++) { // 会员兑换积分，没勾选不要传
						// if (_this[`holiday_vip_level_${i}_check`]) {
							obj[`vip_level_${i}_points`] = _this.holiday_add_form[`vip_level_${i}_points`]
						// }
					}
                	_this.holiday_list[index] = obj
                	_this.holiday_key = Math.random()
                	layer.closeAll()
                });

                _this.$nextTick(() => {
                	_this.innitHolidayDate()
                })
			},

			delHoliday(name, index) {
				let _this = this 

	            layer.confirm('删除后【'+ name +'】将失效，确认删除？', {
	                btn: ['确定', '取消'],
	                title: '提示',
	            }, function() {
					_this.holiday_list.splice(index, 1)
					layer.closeAll()
	            });
			},

		}
	}
</script>

<style lang="less">
	.point-list {
		.rowmargin {
			margin: 0 0 30px;
		}
		.point-type {
			.select2-selection--single {
				height: 32px;
				border-radius: 0;
			}
			.select2-selection__rendered {
				line-height: 32px;
			}
		}
		.table-responsive {
			margin: 30px 0 0;
		}
		.double-select {
			display: flex;
			flex-direction: row;
			align-items: center;
		}
	}
	.detail-pannel {
		.el-input,
		.el-select {
			width: 300px;
		}
		.sub-title {
			margin-left: 20px;
		}
		.gray-block {
			margin: 20px;
			width: 1050px;
			padding: 20px;
			background: #efefef;
			display: flex;
			flex-direction: row;
			flex-wrap: wrap;
			.red-tip {
				font-size: 12px;
				color: red;
				padding-left: 10px;
			}
			.item {
				margin: 20px 30px 10px 0;
			}
			.el-input {
				margin-left: 5px;
			}
		}
		.el-radio-group {
			margin-right: 10px;
		}
		.holiday-wrapper {
			width: 900px;
			margin-left: 20px;
			.holiday-title {
				font-size: 20px;
				margin-top: 20px;
				text-align: center;
			}
			.holiday-table {
				width: 1000px;
				margin-top: 10px;
			}
		}
	}

	.exchange-pop {
		.el-form {
			.el-input,
			.el-select {
				width: 200px;
				margin-right: 10px;
			}
		}
		.el-table__header-wrapper > table > thead .el-checkbox {
			display: none!important;
		}
		.el-table {
			margin-top: 30px;
		}
	}
	// 节假日兑换积分设置弹窗
	.holiday-pop {
		.el-input {
			width: 260px;
			margin-right: 10px;
		}
		.pop-block-title {
			margin: 10px 20px 20px 20px;
		}
		.el-checkbox {
			margin-right: 10px;
		}
	}
	.point-good-alert {
		display: none;
		width: 100%;
		height: 100%;
		padding: 20px 30px;
		input {
			border: 1px solid #FF6700;
		}
		.btns {
			margin-top: 10px;
			position: absolute;
			bottom: 30px;
			#pop-save {
				margin-left: 140px;
			}
		}
		.table-responsive {
			width: 100%;
			padding: 0;
		}
	}
</style>